// Central site configuration — edit values here to update across the entire site
export const SITE = {
  name: "Swipetronics",
  tagline: "Merchant Processing & POS Systems",
  phone: "+1 (877) 794-7369",
  phoneRaw: "+18777947369",
  email: "info@swipetronics.com",
  socials: {
    facebook: "https://www.facebook.com/share/18gKe1Smzy/?mibextid=wwXIfr",
    linkedin: "https://www.linkedin.com/company/swipetronics/",
    instagram: "https://www.instagram.com/swipetronicspos/",
    youtube: "https://www.youtube.com/@swipetronics",
  },
};

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
